module.exports = __webpack_public_path__ + "static/media/icon-rock.8ce1e109.svg";